import * as type from '@/utvStore/store/mutation-types'

const axiosInstance = axios.create({
  timeout: 8000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json'
  }
})

const state = {
  collection: [],
  entry: {},
  questions: []
}

const actions = {
  /**
   * 動画応募詳細を取得
   * @param { Number } itemScheduleId - 対象のitem_schedule_id
   */
  [type.GET_ENTRY_DETAIL]({ commit }, itemScheduleId) {
    return axiosInstance
      .get(`/api/entries/${itemScheduleId}`)
      .then(res => {
        commit(type.GET_ENTRY_DETAIL, res.data)
      })
      .catch(error => {
        throw new Error(error)
      })
  },
  /**
   * カテゴリに紐づく設問内容を取得する
   * @param { Number } params - { category_id: Number }
   */
  [type.GET_ENTRY_QUESTIONS]({ commit }, params) {
    return axiosInstance
      .get('/api/entries/form', { params })
      .then(res => {
        commit(type.GET_ENTRY_QUESTIONS, res.data)
      })
      .catch(error => {
        throw new Error(error)
      })
  }
}

const getters = {
  entryCategory: state => state.entry.category
}

const mutations = {
  [type.GET_ENTRY_DETAIL](_state, entry) {
    Object.assign(_state, { entry })
  },
  [type.GET_ENTRY_QUESTIONS](_state, questions) {
    Object.assign(_state, questions)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/entry.js